import {
  CitationsJWT,
  CitationsJwtError,
  CITATIONS_JWT_TYPE_ERROR,
  CITATIONS_JWT_NULL_CHEGG_TOKENS_ERROR,
} from '@chegg-wt/core/types/auth'

export function parseJwt(token: string): CitationsJWT {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace('-', '+').replace('_', '/')
  return JSON.parse(window.atob(base64)) as CitationsJWT
}

export const invalidTypeError = (type: string) => `Value is of type ${type}`

export const NULL_CHEGG_TOKENS_ERROR = 'cheggTokens is null'
export const MALFORMED_JWT_ERROR = 'JWT format is not valid'
export const INVALID_PAYLOAD_ERROR = 'JWT payload is not valid JSON'

export function validateJwt(token: string): CitationsJwtError | null {
  try {
    const jwt = parseJwt(token)

    if (jwt === null) {
      return new CitationsJwtError(CITATIONS_JWT_TYPE_ERROR, invalidTypeError('null'))
    }

    if (typeof jwt !== 'object') {
      return new CitationsJwtError(CITATIONS_JWT_TYPE_ERROR, invalidTypeError(typeof jwt))
    }

    if (Array.isArray(jwt)) {
      return new CitationsJwtError(CITATIONS_JWT_TYPE_ERROR, invalidTypeError('array'))
    }

    if (jwt.cheggTokens === null) {
      return new CitationsJwtError(
        CITATIONS_JWT_NULL_CHEGG_TOKENS_ERROR,
        NULL_CHEGG_TOKENS_ERROR
      )
    }

    return null
  } catch (e) {
    if (e.message?.match(/^Cannot read.*undefined/)) {
      // Cannot read propert(?:y|(ies)) of undefined
      return new CitationsJwtError(CITATIONS_JWT_TYPE_ERROR, MALFORMED_JWT_ERROR)
    }

    if (e.message?.startsWith('Unexpected token')) {
      return new CitationsJwtError(CITATIONS_JWT_TYPE_ERROR, INVALID_PAYLOAD_ERROR)
    }

    return new CitationsJwtError(CITATIONS_JWT_TYPE_ERROR, e.message)
  }
}

type EvalFunc<T> = (parsedJwt: CitationsJWT) => T

export function evalParsedJwt<T>(
  jwt: string,
  evalFunc: EvalFunc<T>,
  defaultReturn: T | null = null
) {
  if (!jwt) return defaultReturn

  try {
    const parsedJwt = parseJwt(jwt)
    return evalFunc(parsedJwt)
  } catch (e) {
    return defaultReturn
  }
}

export function getSessionId(jwt) {
  try {
    const { sessionId } = parseJwt(jwt)
    return sessionId
  } catch (e) {
    return null
  }
}
